import { Injectable, Inject } from '@angular/core';
import { AuthHttp } from 'angular2-jwt';
import { Http, Headers } from '@angular/http';
import { AuthService } from './auth/auth.service';
import { LoginViewModel } from '../models/login-view-model';
import { userProfile } from '../models/userProfile';
import { OpenActivity } from '../models/OpenActivity';
import { User } from '../models/User';
import { BankAcc } from '../models/BankAcc';
import { CreditPaymentDetails } from '../models/CreditPaymentDetails';
import { Observable } from 'rxjs/Observable';


@Injectable()
export class PayInvoiceService {
  myHeader: Headers;
  constructor(private http: Http,
    private authHttp: AuthHttp,
    public auth: AuthService) {
    this.myHeader = new Headers();
    this.myHeader.append('Content-Type', 'application/json');
    // To fix IE 11 cache API issue.
    this.myHeader.append('Cache-control', 'no-cache');
    this.myHeader.append('Cache-control', 'no-store');
    this.myHeader.append('Expires', '0');
    this.myHeader.append('Pragma', 'no-cache');
    console.log('Pay Invoice Service Initialized...');
  }

  getAllFinancialActivity(contractNumber: string, startdate: string, endDate: string) {
    return this.authHttp.get(`/api/Activity/Open?ContractNumber=${contractNumber}&StartDate=${endDate}&EndDate=${startdate}`,
     {headers: this.myHeader}).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('login request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }
  getPaymentDetails(contractNumber: string, paymentNumber: string) {
    if (!contractNumber) {
      throw new Error('ContractNumber is empty while calling getPaymentDetails');
    } else {
      return this.authHttp.get(`/api/Activity/PaymentDetail?ContractNumber=${contractNumber}&PaymentNumber=${paymentNumber}`, {headers: this.myHeader}).map(res => {
        if (res.status < 200 || res.status > 300) {
          throw new Error('payment details failed ' + res.status);
        } else {
          return res.json();
        }
      }).catch(err => {

        if (err.status === 401 || err.message === 'No JWT present or has expired') {
          this.auth.logOut();
        }

        return Observable.throw(err);
      });
    }
  }

  getOpenActivityData(contractNumber: string) {
    return this.authHttp.get(`/api/Payment/GetOpenActivity/${contractNumber}`, {headers: this.myHeader}).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('login request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }
  getPaymentMethods() {
    return this.authHttp.get(`/api/Payment/GetPaymentMethods`, {headers: this.myHeader}).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('login request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }
  ApplyPayment(creditPaymentDetailsModel: CreditPaymentDetails) {
    return this.authHttp.post(`/api/Payment/ApplyPayment`, creditPaymentDetailsModel, { headers: this.myHeader }).map(res => {
      if (res.status < 200 || res.status > 300) {
        throw new Error('add new contract request has failed ' + res.status);
      } else {
        return res.json();
      }
    }).catch(err => {

      if (err.status === 401 || err.message === 'No JWT present or has expired') {
        this.auth.logOut();
      }

      return Observable.throw(err);
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/services/pay-invoice.service.ts